import React from "react";

function Hero(props) {
    return (
        <section id="home" className="w-full flex justify-center ">
            <div className="z-10  text-peachBlack flex flex-col md:flex-row justify-between md:justify-center items-center rounded-2xl max-w-7xl ">
                <div className="cowgirl-container flex w-fit justify-center">
                    <img
                        className="cowgirl object-cover"
                        src="/images/cowgirl.png"
                        alt=""
                    />
                </div>
                <div className=" md:w-full h-full flex flex-col items-center justify-center p-3 md:p-8">
                    <div className="text-xl md:text-2xl  text-center font-light">
                        Peaches is a waxing studio that specializes in brow
                        shaping and full body waxing. <br />
                        <br /> My mission at Peaches is to provide a welcoming
                        and inclusive environment where every client feels
                        valued and confident. <br />
                        <br /> I am committed to delivering exceptional services
                        using the highest quality products and techniques.{" "}
                        <br />
                        <br /> My goal is to make you feel good in your skin and
                        ensure each visit leaves you feeling refreshed,
                        comfortable, and empowered!
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
